import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  //#region Propiedades

  private _urlService: string

  //#endregion

  //#region Constructor

  constructor() { 

    // Si se compila con ionic build o ng build para subir como PWA
    // o compilar aplicación móvil, siempre apuntamos a producción.
    if (environment.production) {

      if (environment.preproduccion) {

        // Preproducción
        this._urlService = 'https://erp-pre.ingein.com'

      } else {

        // Producción
        this._urlService = 'https://erp.ingein.com'

        // // Pruebas (ReqBin)
        // this._urlService = 'https://reqbin6.fontventa.com'

      }

    } else {

      // Si estamos depurando usamos rutas personalizadas.

      // Producción
      this._urlService = 'https://erp.ingein.com'

      // // Preproducción
      // this._urlService = 'https://erp-pre.ingein.com'

      // // Pruebas
      // this._urlService = 'http://localhost:28245'

      // // Pruebas (ReqBin)
      // this._urlService = 'https://reqbin6.fontventa.com'

    }

  }

  //#endregion

  //#region Getters

  public get urlService(): string {
    return this._urlService
  }

  //#endregion

}
